import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TranslocoRootModule } from './transloco-root.module';
import { HomeComponent } from './features/home/home.component';
import { LoginComponent } from './features/login/login.component';
import { UsersComponent } from './features/users/users.component';
import { ChartsComponent } from './features/charts/charts.component';
import { DevicesComponent } from './features/devices/devices.component';
import { FormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { ChartComponent } from './shared/components/chart/chart.component';
import { LegalDisclaimerComponent } from './shared/components/legal-disclaimer/legal-disclaimer.component';
import { CookiePolicyComponent } from './features/cookie-policy/cookie-policy.component';
import { TopMenuComponent } from './shared/components/top-menu/top-menu.component';
import { NavigatorComponent } from './shared/components/navigator/navigator.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { SelectProjectComponent } from './features/select-project/select-project.component';
import { QueryApiAuthInterceptor } from './core/interceptors/query-api-auth.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    SelectProjectComponent,
    UsersComponent,
    ChartsComponent,
    DevicesComponent,
    HeaderComponent,
    FooterComponent,
    ChartComponent,
    LegalDisclaimerComponent,
    CookiePolicyComponent,
    TopMenuComponent,
    NavigatorComponent,
    BreadcrumbComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslocoRootModule,
    FormsModule,
    HighchartsChartModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: QueryApiAuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
